import { realtimeDatabase } from '~~/service/firebase_config'
import { useEventStore } from '~/store/event'
import { useSlideStore } from '~/store/slide'

import { useWishStore } from '~/store/wish'
import { usePreweddingStore } from '~/store/prewedding'
import { usePromptpayStore } from '~/store/promptpay'
import { useSettingControlStore } from '~/store/settingControl'

import { version } from "~/package.json";
import { ref, push, set, serverTimestamp, onDisconnect } from "firebase/database";
import dayjs from 'dayjs'
import _ from 'lodash'
import _random from 'lodash/random.js'
import _include from 'lodash/includes.js'

const realtimeMonitor = () => {

  const $route = useRoute()
  const eventStore = useEventStore()
  const slideStore = useSlideStore()

  const wishStore = useWishStore()
  const preweddingStore = usePreweddingStore()
  const promptpayStore = usePromptpayStore()

  const settingControl = useSettingControlStore()

  const nonce =_random(1, 1000)
  let presentRef = null
  let startAtDayjs = null //dayjs()

  watch(() => eventStore.eventId, () => {
    setPresentRef()
  })

  watch(() => slideStore.preweddingInstance, () => {
    start()
  })

  watch(() => slideStore.wishInstance, () => {
    start()
  })


  function setPresentRef() {
    const eventId = eventStore.eventId
    presentRef = ref(realtimeDatabase, `live/${eventId}/present`)
    onDisconnect(presentRef).remove()
  }

  function start() {
    if (startAtDayjs == null) {
      startAtDayjs = dayjs()
    }
    const viewMode = slideStore.view

    // get runnging time HH:mm:ss
    const runningTime = dayjs().diff(startAtDayjs, 'seconds')
    const runningTimeHHmm = dayjs().startOf('day').add(runningTime, 'seconds').format('HH:mm:ss')

    const wishByDate = groupWishByDateCount()
      const timer: any = settingControl.timer
    set(presentRef, {
      presentMode: slideStore.playMode,   //  mix || wish
      viewMode: viewMode,   // prewedding || wish
      eventId: eventStore.eventId,
      lastUpdateServerTime: serverTimestamp(),
      lastUpdate: dayjs().format(),
      startAt: startAtDayjs.format(),
      data: viewMode == 'prewedding' ? slideStore.preweddingInstance : slideStore.wishInstance.docId, //  prewedding url | wishData
      nonce: nonce,
      eventDate : eventStore.event?.information?.date,
      // running :  slideStore.limit,
      // runNumber : slideStore.index + 1,
      played_all_instances: slideStore.allInstancesPlayed,
      played_prewedding: slideStore.preweddingInstancesPlayed,
      played_wish: slideStore.wishInstancesPlayed,
      connected_for : runningTimeHHmm,
      version : version,
      loopCount: slideStore.loopCount,
      settingTimer: timer,
      // --- new ---
      inventory: {
        newWishesCount: wishStore.newWishesCount,
        wishByDate: wishByDate, 
        wishes: wishStore?.allWishDatabase?.length || 0,
        prewedding: preweddingStore?.all?.length || 0,
        promptpay: promptpayStore?.promptpayLength | 0
      },
      queue :slideStore.listHolder,
    })
  }

  function stop() {
    set(presentRef, null)
  }
}

function groupWishByDateCount() {
  const wishStore = useWishStore()
  const allWishDatabase = wishStore.allWishDatabase

  let groupByDate =  _.reduce(allWishDatabase, (acc, wish) => {
    const date = dayjs(wish.timestamp.seconds * 1000).format('YYYY-MM-DD')
    if (acc[date]) {
      acc[date]++
    } else {
      acc[date] = 1
    }
    return acc
  }, {})

  return groupByDate
}

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(realtimeMonitor)
})

export {
  realtimeMonitor
}
